import Icon from '../components/Icon.vue'

Icon.register({
  'cloud-sun': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M575.2 325.7C575.4 323.8 576 322 576 320.1 576 284.8 547.3 256.1 512 256.1 499.4 256.1 487.8 259.9 477.9 266.1 460.3 227.3 421.4 200.1 376 200.1 314.2 200.1 264 250.2 264 312.1 264 315.1 264.7 317.9 264.9 320.8 215.3 324.5 176 365.5 176 416.1 176 469.1 219 512.1 272 512.1H544C597 512.1 640 469.1 640 416.1 640 374 612.8 338.7 575.2 325.7zM144.8 303.1C101.1 259.4 101.1 188.4 144.8 144.8 188.5 101.1 259.5 101.1 303.2 144.8 312.9 154.5 320.1 165.7 325.5 177.5 335.3 173.8 345.6 171.5 356.2 170L386 81.1C390 69.2 378.7 58 366.8 61.9L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1L91.2 168.9 8.4 210.4C-2.8 216-2.8 231.9 8.4 237.5L91.2 278.9 61.9 366.7C57.9 378.6 69.2 389.8 81.1 385.9L157.2 360.6C163.3 348.2 171.2 336.9 180.8 327.1 167.7 321.7 155.4 313.7 144.8 303.1zM140 223.9C140 264.7 169.3 298.7 207.9 306.2 215.9 301.5 224.2 297.4 233.1 294.5 238.5 250.2 264.1 212 300.5 189.5 287.3 160.4 258 140 224 140 177.7 140 140 177.6 140 223.9z'
      }
    ]
  }
})
